import { useBreak } from "hooks/useBreak";
import { Label } from "./Overview.label";
import { MobileLabel } from "./MobileOverview.label";

import { _bootstrap } from "state/store.bootstrap";
import { getFocus, useAtom, useGet } from "state/jotai";
import { current_language, rotate_by_slider } from "state/store.global";

import { AnimatePresence, motion } from "framer-motion";

export const Overview = ({
  index,
  rmode,
  status,
  showLabel,
  setShowLabel,
  hoveredId,
}) => {
  const labelOptions = getFocus(_bootstrap, "projectnames");

  const currentLanguage = useAtom(current_language)[0];
  const isRotateDone = useGet(rotate_by_slider);
  const isDesktop = useBreak("md_up");

  // ✅ KEEP (main positions)
  const L = [
    { L1: [1330, 395], L2: [810, 376] },
    { L1: [1262, 396], L2: [1200, 200] },
    { L1: [550, 340], L2: [1184, 350] },
    { L1: [890, 152], L2: [700, 360] },
    { L1: [1330, 395], L2: [810, 376] },
  ];

  // ✅ Mobile positions (kept separate)
  const mobileL = [
    { L1: [1244, 342], L2: [882, 362] },
    { L1: [1200, 354], L2: [1100, 189] },
    { L1: [623, 347], L2: [1153, 300] },
    { L1: [900, 150], L2: [810, 349] },
    { L1: [1244, 342], L2: [882, 362] },
  ];

  const animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.1, ease: "linear" },
  };

  if (!(status === "DONE" && isRotateDone)) return null;

  return (
    <AnimatePresence>
      {labelOptions?.[currentLanguage]?.map((label, i) => {
        if (!i) return null;

        const position = isDesktop
          ? L?.[index]?.[`L${i}`]
          : mobileL?.[index]?.[`L${i}`];

        if (!position) return null;

        return (
          <motion.div {...animation} key={i}>
            {isDesktop ? (
              <Label
                c={position}
                d={40}
                rmode={rmode}
                labelsInfo={label}
                showLabel={showLabel}
                hoveredId={hoveredId}
              />
            ) : (
              <MobileLabel
                c={position}
                d={40}
                rmode={rmode}
                labelsInfo={label}
                showLabel={showLabel}
                setShowLabel={setShowLabel}
                hoveredId={hoveredId}
              />
            )}
          </motion.div>
        );
      })}
    </AnimatePresence>
  );
};